import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import StringBox from "@components/input/strings/StringBox";
import DisplayString from "@components/input/strings/DisplayString";

interface Props {
  value: string;
  name: string;
  onChange: (value: string) => void; 
  multiline?: boolean;
  disabled?: boolean;
  display_name?: boolean;
  fontSize?: number;
  color?: string;
  flash_on_empty?: boolean;
  // log_it?: boolean;
}

export default function EditableLabel({
  value,
  name,
  onChange,
  multiline = false,
  disabled = false,
  display_name = false,
  fontSize = 24,
  color = "header",
  flash_on_empty = false,
  // log_it = false
}: Props) {
  const [my_value, setValue] = useState(value);
  const [prev_value, setPrevValue] = useState(value);
  const [edit, setEdit] = useState(value === "");

  useEffect(() => {
    if (prev_value !== value) {
      setPrevValue(value);
      setValue(value);
      setEdit(value === "");
    }
  }, [prev_value, value, setPrevValue, setValue, setEdit]);

  const render_control = () => {
    if (disabled) {
      if (multiline) {
        return (
          <Grid container spacing={0} direction="column">
            { display_name &&
              <Grid style={{ fontSize: fontSize }} className="header">
                {name}
              </Grid>
            }
            <Grid style={{ fontSize: fontSize }}>
              <DisplayString str={my_value} />
            </Grid>
          </Grid>
        );
      } else {
        return (
          <Grid>
            <div style={{ fontSize: fontSize }}>
              { display_name &&
                <span>
                  {name}:&nbsp;
                </span>
              }
              {my_value}
            </div>
          </Grid>
        );
      }
    } else if (edit) {
      return (
        <div style={{ backgroundColor: "black" }}>
          <StringBox 
            name={name}
            value={my_value}
            multiline={multiline}
            color={ color ? color : "white" }
            className={ my_value === "" && flash_on_empty ? "Flashing" : "" }
            onBlur={(changed: string) => {
              setValue(changed.trim());
              setEdit(changed.trim() === "");
              onChange(changed);
            }}
          />
        </div>
      ); 
    } else {
      if (multiline) {
        return (
          <Grid container spacing={0} direction="column" style={{ cursor: "pointer" }}
            onClick={() => { setEdit(true); }}>
            { display_name &&
              <Grid style={{ fontSize: fontSize }} className="header">
                {name}
              </Grid>
            }
            <Grid style={{ fontSize: fontSize }}>
              <DisplayString str={my_value} />
            </Grid>
          </Grid>
        );
      } else {
        return (
          <Grid style={{ cursor: "pointer" }} onClick={() => { setEdit(true); }}>
            <div style={{ fontSize: fontSize }}>
              { display_name &&
                <span>
                  {name}:&nbsp;
                </span>
              }
              <span>
                {my_value}
              </span>
            </div>
          </Grid>
        );
      }
    }
  }

  if (color === "header") {
    return (
      <div className="header">
        { render_control() }
      </div>
    );
  } else {
    return (
      <div>
        { render_control() }
      </div>
    );
  }
}
